import ChangePasswordModal from './ChangePasswordModal'

export default ChangePasswordModal
